import { IconButton } from "@mui/material";
import ModeIcon from "@mui/icons-material/Mode"


const customStylePrimary = {
    color: "#004D99",
    width: 30,
    height: 30,
};

export interface CustomModifyLoiIconButtonProps {
  title: string;
  currentLoi?: any;
  onCallBack: (currentLoi?: any) => void;
}

const CustomModifyLoiIconButton = ({title, onCallBack, currentLoi}: CustomModifyLoiIconButtonProps) => {



    return<div className="d-inline w-25">
        <IconButton aria-label="modify" style={customStylePrimary} title={title} onClick={() => onCallBack(currentLoi)}>
            <ModeIcon/>
        </IconButton>
    </div>
}

export default CustomModifyLoiIconButton;
